import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "../componets/nav";
import "./gallery.css";
import Masonry from "react-masonry-css";

// Import small thumbnails (recommended) and large versions separately
// If you don't have thumbnails yet, keep using your normal images but lazy load them.

import {
  trackThumbs,
  trackLarge,
  showThumbs,
  showLarge,
} from "../services/loadImages";

// Sample video data - replace with your actual videos
const videoData = [
  {
    id: "video-1",
    title: "Steelblade Photography - Automotive Showcase",
    thumbnail: "https://img.youtube.com/vi/zEnyRxbKIzM/maxresdefault.jpg",
    videoUrl: "https://www.youtube.com/embed/zEnyRxbKIzM",
    description:
      "Experience the raw power and beauty of automotive excellence captured by Steelblade Photography",
  },
];

// … repeat above pattern for all your images

const portfolioData = {
  trackPhotography: trackThumbs.map((thumb, i) => ({
    id: `track-${i + 1}`,
    thumb,
    full: trackLarge[i], // match by index
    alt: `Track photography shot ${i + 1}`,
  })),
  carShowExhibitions: showThumbs.map((thumb, i) => ({
    id: `show-${i + 1}`,
    thumb,
    full: showLarge[i], // match by index
    alt: `Car show & exhibition shot ${i + 1}`,
  })),
  video: videoData,
};
console.log(portfolioData);

const Gallery = () => {
  const [activeTab, setActiveTab] = useState("trackPhotography");
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const location = useLocation();

  // Handle URL parameters to set the active tab
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get("tab");
    if (tabParam && portfolioData[tabParam]) {
      setActiveTab(tabParam);
    }
  }, [location]);

  // Disable right-click & common shortcuts on images
  useEffect(() => {
    const handleContextMenu = (e) => {
      if (e.target.tagName === "IMG") {
        e.preventDefault();
      }
    };
    const handleKeyDown = (e) => {
      if (
        (e.ctrlKey && (e.key === "s" || e.key === "a" || e.key === "c")) ||
        e.key === "F12"
      ) {
        e.preventDefault();
      }
    };
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const openModal = (image) => {
    setSelectedImage(image);
    console.log("Clicked image:", image); // <-- add this
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const nextVideo = () => {
    setCurrentVideoIndex((prev) => (prev + 1) % videoData.length);
  };

  const prevVideo = () => {
    setCurrentVideoIndex(
      (prev) => (prev - 1 + videoData.length) % videoData.length
    );
  };

  const breakpointColumnsObj = {
    default: 4,
    1200: 3,
    900: 2,
    600: 1,
  };

  return (
    <div className="portfolio-page">
      <Nav />
      <div className="portfolio-container">
        <header className="portfolio-hero">
          <h1 className="portfolio-title">Gallery</h1>
          <p className="portfolio-subtitle">
            Capturing speed, precision, and automotive excellence
          </p>
        </header>

        {/* Filter Tags */}
        <div className="portfolio-filters">
          {Object.keys(portfolioData).map((tab) => (
            <button
              key={tab}
              className={`filter-btn ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab === "trackPhotography"
                ? "Track Photography"
                : tab === "carShowExhibitions"
                  ? "Car Shows & Exhibitions"
                  : "Videos"}
            </button>
          ))}
        </div>

        {/* Image Gallery */}
        {activeTab !== "video" ? (
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="portfolio-gallery"
            columnClassName="gallery-column"
          >
            {portfolioData[activeTab].map((image) => (
              <div
                key={`${activeTab}-${image.id}`}
                className="gallery-item"
                onClick={() => openModal(image)}
              >
                <img
                  src={image.thumb}
                  alt={image.alt}
                  loading="lazy"
                  className="gallery-img"
                />
                <div className="gallery-overlay">
                  <span className="overlay-text">View Full Size</span>
                </div>
              </div>
            ))}
          </Masonry>
        ) : (
          /* Video Carousel */
          <div className="video-carousel">
            <div className="carousel-container">
              <button className="carousel-btn prev-btn" onClick={prevVideo}>
                ❮
              </button>

              <div className="carousel-content">
                <div className="video-player">
                  <iframe
                    width="100%"
                    height="500"
                    src={videoData[currentVideoIndex].videoUrl}
                    title={videoData[currentVideoIndex].title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>

                <div className="video-info">
                  <h3 className="video-title">
                    {videoData[currentVideoIndex].title}
                  </h3>
                  <p className="video-description">
                    {videoData[currentVideoIndex].description}
                  </p>
                  <div className="carousel-indicators">
                    {videoData.map((_, index) => (
                      <div
                        key={index}
                        className={`indicator ${index === currentVideoIndex ? "active" : ""}`}
                        onClick={() => setCurrentVideoIndex(index)}
                      />
                    ))}
                  </div>
                </div>
              </div>

              <button className="carousel-btn next-btn" onClick={nextVideo}>
                ❯
              </button>
            </div>

            {/* Video Thumbnails */}
            <div className="video-thumbnails">
              {videoData.map((video, index) => (
                <div
                  key={video.id}
                  className={`video-thumbnail ${index === currentVideoIndex ? "active" : ""}`}
                  onClick={() => setCurrentVideoIndex(index)}
                >
                  <img src={video.thumbnail} alt={video.title} />
                  <span className="play-icon">▶</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Modal for full-size image */}
        {selectedImage && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={closeModal}>
                ×
              </button>
              <div className="modal-image-container">
                <img
                  src={selectedImage.full} // load full size only now
                  alt={selectedImage.alt}
                  className="modal-image"
                  loading="eager"
                />
                <div className="modal-watermark-overlay">
                  <div className="watermark-center">STEELBLADE</div>
                  <div className="watermark-center-sub">PHOTOGRAPHY</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Gallery;
